// 将代码封装在一个对象中
const printerSdk = {
  websocket: null,
  ackJsonData: '',
  messageList: {},
  timeoutTimer: null,
  timeoutDuration: 10000,

  sendMsg(msg, callback) {
    console.log("timeout_duration", this.timeoutDuration);
    console.log('sendMsg', msg.apiName);
    this.messageList[msg.apiName] = callback;

    const data = JSON.stringify(msg);

    if (!this.websocket || this.websocket.readyState !== WebSocket.OPEN) {
      if (callback && typeof callback === 'function') {
        callback(new Error("打印服务未开启"));
      }
      return;
    }
    this.timeoutTimer = setTimeout(() => {
      console.log('回调超时');
      callback(new Error("打印服务消息接收超时"));
    }, this.timeoutDuration);

    this.websocket.send(data);
  },

  getInstance(onServiceConnected, onNotSupportedService) {
    const connect = () => {
      if ('WebSocket' in window) {
        this.websocket = new WebSocket('ws://127.0.0.1:37989');
        this.websocket.binaryType = 'arraybuffer';

        this.websocket.onopen = (event) => {
          console.log('WebSocket connected !');
          onServiceConnected();
        };

        this.websocket.onerror = (event) => {
          console.log('WebSocket error !', event);
          onNotSupportedService();
        };

        this.websocket.onmessage = (event) => this.readCallback(event);

        this.websocket.onclose = (event) => {
          console.log('WebSocket close !', event);
        };
      } else {
        onNotSupportedService();
      }
    };

    connect();
  },

  close() {
    if (this.websocket !== null) {
      this.websocket.close();
    }
  },

  readCallback(event) {
    const callBackInfo = event.data;
    console.log('readCallback', callBackInfo);
    this.ackJsonData = callBackInfo;

    if (this.isJSON(this.ackJsonData)) {
      const arrParse = JSON.parse(this.ackJsonData);
      const callbackName = arrParse.apiName;

      if (this.messageList[callbackName]) {
        this.messageList[callbackName](null, arrParse);
      }
    }
  },

  isJSON(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  },

  onCoverStatusChange(coverStatus) {
    console.log('打印机盒盖有变化！');
  },
  onElectricityChange(powerLever) {
    console.log('打印机电量有变化！');
  },
  initSdk(json, callbackFunction) {
    var jsonObj = {
      apiName: 'initSdk',
      parameter: json
    };
  
    sendMsg(jsonObj, callbackFunction);
  },
  getAllPrinters(callbackFunction) {
    //刷新设备时，关闭设备
    //closePrinter();
    var jsonObj = { apiName: 'getAllPrinters' };
  
    sendMsg(jsonObj, callbackFunction);
  },
  scanUSBPrinters(callbackFunction) {
    //刷新设备时，关闭设备
    //closePrinter();
    var jsonObj = { apiName: 'scanUSBPrinters' };
  
    sendMsg(jsonObj, callbackFunction);
  },
  scanWifiPrinter(callbackFunction) {
    timeout_duration = 25000;
    //刷新设备时，关闭设备
    //closePrinter();
    var jsonObj = { apiName: 'scanWifiPrinter' };
  
    sendMsg(jsonObj, callbackFunction);
  },
  selectPrinter(printerName, port, callbackFunction) {
    var jsonObj = {
      apiName: 'selectPrinter',
      parameter: { printerName: printerName, port: port }
    };
    sendMsg(jsonObj, callbackFunction);
  },
  
  // 其他方法定义...

};

// 导出printerSdk对象
export default printerSdk;



// WEBPACK FOOTER //
// ./src/utils/plugins/jsPrinterPlugin.js